import React, { useState } from 'react';
import { Routes, Route, useNavigate } from 'react-router-dom';
import PresentationPage from './components/PresentationPage';
import KidsPage from './components/KidsPage';
import BusinessForm from './components/BusinessForm';
import ServicePage from './components/ServicePage';

function App() {
  const [showForm, setShowForm] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <Routes>
        <Route path="/servicii/:slug" element={<ServicePage />} />
        <Route
          path="/"
          element={
            <PresentationPage
              onSwitchToKids={() => navigate('/kids')}
              onOpenForm={() => setShowForm(true)}
            />
          }
        />
        <Route
          path="/kids"
          element={
            <KidsPage
              onSwitchToMain={() => navigate('/')}
            />
          }
        />
      </Routes>

      {showForm && (
        <BusinessForm onClose={() => setShowForm(false)} />
      )}
    </>
  );
}

export default App;
